import SmoothScrollMixin from "~/mixin/animations/SmoothScrollMixin";
import CursorMixin from "~/mixin/animations/CursorMixin";

export {
    SmoothScrollMixin,
    CursorMixin
}
